import type { TextBlock } from '../interfaces/textEditor.interface';
import { extractTextFromBlocks } from './textBlockExtractor';

export interface ReplyPreview {
  /** The text to render in the drawer — full body, or a word-boundary snippet + "…". */
  text: string;
  /** True when the reply was longer than the cap and got snipped. */
  truncated: boolean;
}

/**
 * TRIL-353: build the replies-drawer preview for a reply. Uses the same plain-text
 * extraction the analyzer uses (`extractTextFromBlocks`) so the char count matches
 * length enforcement elsewhere. Replies under `max` render in full; longer ones are
 * cut on a word boundary and get an ellipsis, with the full body living on the
 * reply detail page (the "View reply →" link, TRIL-349).
 */
export const truncateReplyPreview = (
  textBlocks: TextBlock[],
  max: number,
): ReplyPreview => {
  const text = extractTextFromBlocks(
    Array.isArray(textBlocks) ? textBlocks : [],
  );
  if (text.length <= max) {
    return { text, truncated: false };
  }

  const slice = text.slice(0, max);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace > 0 ? slice.slice(0, lastSpace) : slice;
  return { text: `${cut.trimEnd()}…`, truncated: true };
};
